import { useEffect, useState } from "react";
import { message, Space } from 'antd';
import { uploadFile } from "@/services/workflow";
import { PlayCircleOutlined, PauseCircleOutlined } from '@ant-design/icons';

interface RecorderProps {
  voice: string;
  setVoice: (url: string) => void;
}

const Recorder: React.FC<RecorderProps> = ({ voice, setVoice }) => {
  const [media, setMedia] = useState<MediaRecorder>();
  const [iconType, setIconType] = useState<'play' | 'stop'>('play');

  useEffect(() => {
    init();
    return media?.removeEventListener('dataavailable', upload);
  }, [])

  const upload = async (e: BlobEvent) => {
    // setAudioUrl(URL.createObjectURL(e.data));
    const formData = new FormData();
    formData.append('file', e.data, `${new Date().getMilliseconds()}.mp3`);
    const { resp } = await uploadFile(formData);
    if (resp?.code !== 0) return;
    setVoice(resp.data.url);
  }
  
  const init = () => {
    if (media) return;
    const constraints = { audio: true, video: false };
    if (!navigator.mediaDevices) return message.warning('无法初始化麦克风设备，运行环境不为localhost或通信协议不是https！');
    navigator.mediaDevices.getUserMedia(constraints).then(function(stream) {
      const media = new MediaRecorder(stream);
      media.addEventListener('dataavailable', upload);
      setMedia(media);
      message.success('已初始化麦克风，可进行音频录制');
    }).catch(function(err) {
      message.warning('请授权麦克风权限！');
    })
  }

  const start = () => {
    if (!media) return init();
    setIconType('stop');
    media.start();
    message.info('录制中...');
  }

  const stop = () => {
    if (!media) return;
    setIconType('play');
    media.stop();
    message.info('录制结束');
  }

  const iconStyle = { fontSize: 40, color: 'rgba(0, 0, 0, 0.7)' } as React.CSSProperties;

  return <Space direction="vertical">
    {
      iconType === 'play' ? <PlayCircleOutlined style={iconStyle} onClick={start}/> : <PauseCircleOutlined style={iconStyle} onClick={stop}/>
    }
    {
      voice && <audio controls src={voice} />
    }
  </Space>
}

export default Recorder;